import config from '../config'

export default {
    getAutocompleteAddress(query, location = null) {
        return config.dataGouvVendor.autocompleteAddress(query, location)
    }
}
